import { render, staticRenderFns } from "./GCalculateSalaryProcessUploadBordro.vue?vue&type=template&id=814666c8&"
import script from "./GCalculateSalaryProcessUploadBordro.vue?vue&type=script&lang=js&"
export * from "./GCalculateSalaryProcessUploadBordro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports